import { Sites } from '@ps/platform-message-framework/common/Sites';
import { FeatureFlag } from '@ps/web-core-enums';
import { select } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import useFeature from '@swf/core/hooks/useFeature';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import useWizardExit from '@swf/core/hooks/useWizardExit';

import { CashierFlowType } from '../../../../types/Cashier';
import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import DOB from '../../../DOB/DOB';
import useRmfFirstScreen from '../../hooks/useRmfFirstScreen';
import useTransitionScreenHandler from '../../hooks/useTransitionScreenHandler';
import RMFTransitionScreen from '../RMFTransitionScreen/RMFTransitionScreen';

import {
  TXTWCL_How_old_are_youX,
  TXTWCL_We_need_your_date_of_birth_to__ELL,
  TXTWCL_When_were_you_bornX
} from './RMFDOB.messages.json';

const RMFDOB: React.FC = () => {
  const isSumSubEnabled = useFeature(FeatureFlag.SwcSignupRmfSumSub);
  const isAutofocusEnabled = useFeature(FeatureFlag.SwcSignupRmfAutofocus);
  const legalAge = useSelector(select.cms.getLegalAge);
  const [shouldAutoFocus, setShouldAutoFocus] = useState(false);
  const [isTransitionVisible, closeTransitionScreen] = useTransitionScreenHandler();
  const isFirstScreen = useRmfFirstScreen();
  const isItaly = useSelector(select.cms.getSiteId) === Sites.ITA;
  const exitWizard = useWizardExit();

  useEffect(() => {
    if (isTransitionVisible !== undefined) {
      setShouldAutoFocus(isAutofocusEnabled && !isTransitionVisible);
    }
  }, [isAutofocusEnabled, isTransitionVisible]);

  const {
    data: { cashierFlow, rmfTargetToJump, fieldsMap }
  } = useWizardContext();

  const isFirstPageInCashierFlows =
    isEmpty(fieldsMap) &&
    (cashierFlow === CashierFlowType.FirstP2pTransfer ||
      (cashierFlow === CashierFlowType.FirstWithdraw &&
        rmfTargetToJump !== '#withdraw.get-cashout-options'));

  return (
    <Container
      page={RMFDOB}
      headerProps={{
        title: <Translation {...TXTWCL_When_were_you_bornX} />,
        buttons: {
          back: (!isFirstScreen && !isSumSubEnabled) || isItaly || isFirstPageInCashierFlows,
          onBackClick: isFirstPageInCashierFlows ? exitWizard : undefined
        }
      }}
      pageTopTitle={<Translation {...TXTWCL_How_old_are_youX} />}
      pageTopSubtitle={
        <Translation {...TXTWCL_We_need_your_date_of_birth_to__ELL} values={{ 0: legalAge }} />
      }
    >
      <fieldset>
        <DOB hasBeenShown={shouldAutoFocus} />
      </fieldset>
      <CTAButton />
      {isTransitionVisible && !isSumSubEnabled && (
        <RMFTransitionScreen handleButtonClick={closeTransitionScreen} />
      )}
    </Container>
  );
};

RMFDOB.displayName = 'RMFDOB';

export default RMFDOB;
